import type { ReactNode } from 'react'
import { Sidebar } from './sidebar'
import { HeaderBar } from './header-bar'

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="flex min-h-screen bg-bg-app">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <HeaderBar />
        <main className="flex-1 px-8 py-8">{children}</main>
      </div>
    </div>
  )
}
